<template lang="pug">
.cp-home
  .banner
    #iSlider-wrapper
  .list-links
    a.link1.ani-card(href="/#/news", target="_black")
      b 新闻动态
    a.link2.ani-card(href="/#/robot3/design", target="_black")
      b 颜值至上
    //- a.link3.ani-card(href="//v.qq.com/x/page/r0538txqcoz.html", target="_black")
    a.link3.ani-card(@click="showVideo=1")
      b 了解维拉
  .partners
    .pp 合作伙伴
    .logo-list
      ul.ul1
        li(v-for="n in partners1", :style="{backgroundImage: 'url(static/images/partners/'+n+'.png)'}")
        li(v-for="n in partners1", :style="{backgroundImage: 'url(static/images/partners/'+n+'.png)'}")
      ul.ul2(style="margin-left: -50px")
        li(v-for="n in partners2", :style="{backgroundImage: 'url(static/images/partners/'+n+'.png)'}")
        li(v-for="n in partners2", :style="{backgroundImage: 'url(static/images/partners/'+n+'.png)'}")
  transition(name="fade")
    .video-wrap(v-show="showVideo")
      .mask(@click="closeVideo")
      .btn-close(@click="closeVideo") +
      iframe(v-if="showVideo", frameborder="0",allowfullscreen, src="https://v.qq.com/iframe/player.html?vid=r0538txqcoz")
</template>

<script>
let Slide = null
const sliderList = [
  { content: `
    <a href="#/robot3s/info" class="slide" style="background-image: url(static/images/banner3.jpg?v=1)">
      <div class="text text1">
        <p class="p1">机器人智慧康养社区</p>
        <p class="p2">服务更贴心  运营更高效</p>
        <p class="p3">了解更多></p>
      </div>
    </a>`
  },
  { content: `
    <a href="#/robot3/info" class="slide" style="background-image: url(static/images/banner1.jpg?v=1)">
      <div class="text text1">
        <p class="p1">定义AI智慧生活</p>
        <p class="p2">维拉3.0 ¥39,999元/套</p>
        <p class="p3">了解更多></p>
      </div>
    </a>`
  },
  { content: `
    <a href="#/robot2s/info" class="slide" style="background-image: url(static/images/banner2.jpg?v=1)">
      <div  class="text text1">
        <p class="p1">未来之选 尽显科技</p>
        <p class="p2">维拉2.0 ¥18,999元/套</p>
        <p class="p3">了解更多></p>
      </div>
    </a>`
  },
]

export default {
  name: 'home',
  data () {
    return {
      showVideo: false,
      animationIndex: 0,
      partners1: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17],
      partners2: [18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38],
    }
  },
  computed: {},
  methods: {
    closeVideo () {
      this.showVideo = false
    },
    initSlide () {

      Slide = new iSlider({
        dom: document.getElementById('iSlider-wrapper'),
        data: sliderList,
        fixPage: false,
        isAutoplay: true,
        duration: 3000,
        isLooping: 3000,
        plugins: ['dot']
      })
    },
    initPartnersCss () {
      let n1 = this.partners1.length
      let n2 = this.partners2.length

      let s = `
        @keyframes -ms-loop1 { 100% {transform: translateX(-${250 * n1}px)}}
        @keyframes -webkie-loop1 {100% {transform: translateX(-${250 * n1}px)}}
        @keyframes loop1 {100% {transform: translateX(-${250 * n1}px)}}

        @keyframes -ms-loop2 { 100% {transform: translateX(-${250 * n2}px)}}
        @keyframes -webkie-loop2 {100% {transform: translateX(-${250 * n2}px)}}
        @keyframes loop2 {100% {transform: translateX(-${250 * n2}px)}}

        .cp-home .partners .ul1 {
          -ms-animation: loop1 ${4*n1}s linear infinite;
          -webkie-animation: loop1 ${4*n1}s linear infinite;
          animation: loop1 ${4*n1}s linear infinite;
        }
        .cp-home .partners .ul2 {
          -ms-animation: loop2 ${4*n2}s linear infinite;
          -webkie-animation: loop2 ${4*n2}s linear infinite;
          animation: loop2 ${4*n2}s linear infinite;
        }
      `

      let styleObject = document.createElement('style')
      styleObject.type = 'text/css'
      styleObject.innerHTML = s
      document.getElementsByTagName('head')[0].appendChild(styleObject)
    }
  },
  created () {
    this.initPartnersCss()
  },
  mounted () {
    this.initSlide()
  }
}
</script>

<style lang="stylus">
@import 'config'
.cp-home
  .banner
    position relative
    min-width 1200px
    height 750px
    overflow hidden
    .islider-dot-wrap
      position absolute
      bottom 30px
      left 0
      width 100%
      z-index 10
      text-align center
      li
        width 60px
        height 6px
        margin 0 10px
        display inline-block
        background-color #fff
        font-size 0
        &.active
          background-color #3bc0bc
    #iSlider-wrapper
      height 100%
    .islider-outer
      position relative
      height 100%
      li
        position absolute
        top 0
        left 0
        height 100%
        width 100%
      .slide
        display block
        position relative
        width 100%
        height 100%
        background-size auto 100%
        background-position center
        background-repeat no-repeat
        .text
          position absolute
          width 100%
          top 50px
          text-align center
          line-height 1.7
          .p1
            font-size 46px
            color #4c4c4c
            opacity 0
          .p2
            font-size 24px
            color #4c4c4c
            opacity 0
          .p3
            display block
            font-size 19px
            color #00a9a8
            opacity 0
        .text2
          .p1
            padding-top 80px
            color #fff
          .p2
            margin-top 120px
            font-size 24px
            color #4ce2af

      .islider-active
        .p1
          animation fadeUp 1s forwards
        .p2
          animation fadeUp 1s .5s forwards
        .p3
          animation fadeUp 1s .8s forwards
  .list-links
    margin 45px 0
    text-align center
    a
      display inline-block
      width 370px
      height 310px
      padding-top 240px
      background-position top center
      background-repeat no-repeat
      b
        display block
        height 70px
        line-height 70px
        font-size 18px
        border 2px solid #f5f7f9
        border-top none
    .link1
      background-image url('../assets/web/link1.png')
    .link2
      margin 0 20px
      background-image url('../assets/web/link2.png')
    .link3
      background-image url('../assets/web/link3.png')
  .partners
    background #f5f7f9
    .pp
      font-size 40px
      margin 0 auto
      text-align center
      width 370px * 3 + 40px
      border-bottom 1px solid #eae9e9
      padding 40px 0
    .logo-list
      padding 85px 0
      width: 100%
      overflow: hidden
      white-space: nowrap
      ul
        li
          width 250px
          height 156px
          display inline-block
          background-size cover
  .video-wrap
    position fixed
    z-index 20
    top 0
    left 0
    width 100%
    height 100%
    .btn-close
      position absolute
      right 50%
      bottom 20px
      color #fff
      font-size 60px
      transform rotate(45deg) translatey(-50%)
    .mask
      position absolute
      top 0
      left 0
      width 100%
      height 100%
      background rgba(0,0,0,.8)
    iframe
      position relative
      z-index 30
      width 80%
      height 80%
      margin 30px 0 0 10%
.is-mobile
  .cp-home
    .video-wrap
      iframe
        height r(600)
        margin-top r(200)
    .banner
      min-width inherit
      height r(1100)
      .islider-dot-wrap
        bottom r(30)
        li
          width r(70)
          height r(4)
          margin 0 r(10)
      .islider-outer
        .slide
          .text
           .p1
            font-size r(46)
          .p2
            font-size r(24)
          .p3
            font-size r(20)
    .list-links
      margin r(20) 0
      a
        width r(600)
        height r(500)
        background-size 100% auto
        padding-top r(385)
        b
          height r(90)
          line-height r(90)
          border-left none
          border-right none
          border-top none
    @keyframes loop
      100%
        transform translateX(-250px * 0.5 * 8)
    .partners
      .pp
        font-size r(30)
        width 100%
        padding r(40) 0
      .logo-list
        padding r(70) 0
        ul
          li
            padding r(70) 0
            width 250px * 0.5
            height 156px * 0.5
</style>



// WEBPACK FOOTER //
// src/views/home.vue